module.exports = {"title":"Week 5: Continuation","body":"<p>The existing code runs but there are still some missing files… We finished up work on running the majority of the existing code and began work on automating the entire process.</p>\n"}


//////////////////
// WEBPACK FOOTER
// ./process/week-5/index.md
// module id = 496
// module chunks = 0